export default __webpack_public_path__ + "static/media/breakfast1.39b63879.jpeg";